<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="email-ver-required">
    <h1 class="email-ver-required__title">{{ title }}</h1>
    <img class="email-ver-required__icon"
         :src="emailVerificationIcon"
         alt="Email verification required icon">
    <div class="email-ver-required__body" v-html="message" />
    <a href="/login?xAIMobile=true" class="email-ver-required__btn">More ways to sign in</a>
  </div>
</template>

<script>
import emailVerificationIconPath from '~_acaAssets/error/no-connection.svg';

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        }
    },
    computed: {
        emailVerificationIcon() {
            return emailVerificationIconPath;
        }
    },
    mounted() {
        this.$store.dispatch('app/setNoHeaderState');
    },
    beforeUnmount() {
        this.$store.commit('app/SET_NO_HEADER_CLASS', '');
    }
};
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.email-ver-required {
  display: flex;
  flex-direction: column;
  align-items: center;

  .email-ver-required__title {
    .ds1-ma-0();
    font-size: 28px;
    line-height: 36px;
    font-weight: 400;
  }

  .email-ver-required__icon {
    .ds1-mt-6();
    .ds1-mb-5();
    width: 112px;
    height: 112px;
  }

  .email-ver-required__body {
    text-align: left;
  }

  .email-ver-required__btn {
    .ds1-mt-6();
    display: inline-block;
    padding: 10px 20px;
    background-color: @WKCE-CREAM-SHADE1;
    color: @WKCE-WHITE;
    text-decoration: none;
    border-radius: 50px;
    width: 100%;
    box-sizing: border-box;

    &:hover {
      background-color: @WKCE-CREAM-SHADE2;
    }
  }
}
</style>

<style lang="less">
  #utd-main.utd-content-main.utdError {
    top: 0;
  }
</style>